import AbstractProvider from '../services/App/AbstractProvider';
import {IDatabase} from '../@interfaces/services/Database';
import {IStoreEvents} from '../@interfaces/services/StoreEvents/IStoreEvents';
import WorkSchedule from '@src/services/Database/Models/WorkSchedule';
import {IReduxAppState} from '@src/@interfaces';
import {setWorkSchedule} from '@src/_redux/app/actions';
import {IWorkSchedule} from '@src/@interfaces/services/Database/IWorkSchedule';
import {APP_SET_WORK_SCHEDULE} from '@src/_redux/app/constants';

export class WorkScheduleProvider extends AbstractProvider {
    holdBootUntilNotCompleted = false;

    async boot(): Promise<void> {
        this.subscribeToStoreEvents();

        if (!this.app.config.get('client.store-data-in-db') as boolean) {
            return;
        }

        const table = this.getStoredService<IDatabase>('db').workSchedule;
        if (!table) {
            return;
        }

        const schedule = WorkSchedule.query<IWorkSchedule>().toArray().then(list => {
            return list.reduce<Partial<IReduxAppState['workSchedule']>>((res, item) => {
                res[item.key] = item.value;

                return res;
            }, {});
        });
        if (schedule && Object.keys(schedule).length === 3) {
            this.app.dispatchAction(setWorkSchedule(schedule as unknown as IReduxAppState['workSchedule']));
        }
    }

    protected subscribeToStoreEvents() {
        const dispatcher = this.getStoredService<IStoreEvents>('store-events');

        dispatcher.listen(APP_SET_WORK_SCHEDULE, (e, payload) => {
            const schedule: IReduxAppState['workSchedule'] | undefined = payload.action?.payload?.schedule;
            if (!schedule) {
                return;
            }

            const keys = Object.keys(schedule) as (keyof IReduxAppState['workSchedule'])[];

            keys.map(name => {
                if (!schedule[name]) {
                    return Promise.resolve();
                }

                return WorkSchedule.updateOrCreate<IWorkSchedule>(
                    {key: name},
                    {value: schedule[name]}
                );
            });
        });
    }
}
